import './InsertModal.css';
import { useState, useRef, useContext } from 'react';
import { useTranslation } from 'react-i18next'; // Importa o hook de tradução
import DragAndDrop from '../../../../components/DragAndDrop';
import { AuthContext } from '../../../../authContext';

function InsertModal({ isOpen, onClose, user, triggerUpdate, documentList, assistant, assistantId, sessionId }) {
  const [status, setStatus] = useState(''); // Estado para armazenar o status do novo arquivo
  const [isLoading, setIsLoading] = useState(false);
  const [pdfFiles, setPdfFiles] = useState([]); // Agora armazenando múltiplos arquivos
  const fileInputRef = useRef(null);
  const { accessToken, setAccessToken } = useContext(AuthContext);
  const { t } = useTranslation(), { t: tDatabase } = useTranslation('database'); // Hook de tradução

  if (!isOpen) return null;

  // Função para remover um arquivo selecionado
  const removeFile = (index) => {
    setPdfFiles(prevFiles => prevFiles.filter((_, i) => i !== index));

    // Verifica se a referência ao input existe antes de acessá-la
    if (fileInputRef.current) {
      fileInputRef.current.value = '';  // Reseta o valor do input
    }
  };

  // Função para fechar o modal ao clicar fora do conteúdo
  const handleClickOutside = (event) => {
    if (event.target.classList.contains('modal-overlay-insert')) {
      handleCloseModal();
    }
  };

  // Função para fechar o modal e redefinir estados
  const handleCloseModal = () => {
    setPdfFiles([]); // Limpar todos os arquivos
    setStatus('');
    onClose();
  };

  // Função para enviar arquivos para o backend
  const uploadToBackend = () => {

    if (pdfFiles.length === 0 || !status) {
      alert(tDatabase('selectFilesAndStatus'));
      return;
    }

    setIsLoading(true);

    const formData = new FormData();
    //formData.append('user', user);
    formData.append('session_id', sessionId);
    //formData.append('assistant_id', assistantId);
    //formData.append('assistant', assistant);   
    formData.append('status', status);
    pdfFiles.forEach(file => {
      formData.append('files', file); // Alterado de 'pdf' para 'files'
    });

    fetch(`${process.env.REACT_APP_API_URL}/post_insert_site`, {
      method: 'POST',
      headers: {
        "Authorization": `Bearer ${accessToken}`
      },
      body: formData,
    })
      .then(async (response) => {
        const data = await response.json().catch(() => ({}));
        if (!response.ok) {
          const msg = data.error || `Erro HTTP ${response.status}`;
          throw new Error(msg);
        }
        if (data.error) {
          throw new Error(data.error);
        }
        return data;
      })
      .then((data) => {
        const summary = data.docs || {};
        const inserted = summary.inserted_files?.length ?? 0;
        const skipped = summary.skipped_duplicates?.length ?? 0;
        const chunks = summary.chunks_uploaded ?? 0;
        const errs = summary.errors || [];
        if (inserted === 0 && chunks === 0) {
          const parts = [];
          if (skipped > 0) {
            parts.push(`${skipped} ficheiro(s) ignorados (já existiam com o mesmo nome).`);
          }
          if (errs.length > 0) {
            parts.push(`${errs.length} ficheiro(s) com erro (ex.: PDF sem texto extraível).`);
          }
          if (parts.length === 0) {
            parts.push('Nenhum chunk foi enviado ao índice. Verifica duplicados ou PDFs vazios.');
          }
          alert(parts.join(' '));
        } else {
          if (skipped > 0) {
            alert(
              `${skipped} ficheiro(s) ignorados por já existirem; ${inserted} novo(s) processado(s).`
            );
          }
        }
        if (inserted > 0 && errs.length > 0) {
          alert(
            `Upload parcial: ${inserted} ficheiro(s) aceites, ${errs.length} com erro. Detalhes no servidor (logs).`
          );
        }
        setPdfFiles([]);
        setStatus('');
        // Azure Search pode demorar alguns segundos a tornar documentos pesquisáveis
        triggerUpdate();
        setTimeout(() => triggerUpdate(), 5000);
        onClose();
      })
      .catch((error) => {
        console.error('Insert Error:', error);
        alert(error.message || 'Falha no upload');
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <div className="modal-overlay-insert" onClick={handleClickOutside}>
      <div className={`modal-content-insert`}>

        <DragAndDrop setFiles={setPdfFiles} multipleFiles={true} fileInputRef={fileInputRef} acceptedTypes='.pdf' />

        {pdfFiles.length > 0 && (
          <div className="file-selected">

            <div className='title-select'>
              <h3>{tDatabase('loaded_files')}</h3>
              <select className="status-select" value={status} onChange={(e) => setStatus(e.target.value)}>
                <option value="" disabled hidden>{tDatabase('status')}</option>
                <option value="Official">{tDatabase('official')}</option>
                <option value="Draft">{tDatabase('draft')}</option>
              </select>
            </div>

            <div className='file-group'>
              {pdfFiles.map((file, index) => (
                <div key={index} className="file-item2">
                  <button className="file-button">
                    <div className="filename-container">
                      {file.name}
                    </div>
                    <img
                      src="/imagens/exclude.svg"
                      alt={tDatabase('removeFile')}
                      className="remove-file-icon"
                      onClick={() => removeFile(index)} // Agora com suporte para múltiplos arquivos
                    />
                  </button>
                </div>
              ))}
            </div>


            <button
              className={`replace-button ${isLoading ? 'loading' : ''}`}
              onClick={uploadToBackend}
              disabled={isLoading}
            >
              {isLoading ? t('loading') : t('insert')}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default InsertModal;
